export const menuItems = [
  // {
  //   key: "1",
  //   label: (
  //     <a  rel="noopener noreferrer" href="/form">
  //       Microbiome
  //     </a>
  //   ),
  // },
  // {
  //   key: "2",
  //   label: (
  //     <a  rel="noopener noreferrer" href="/parasitologyform">
  //       Parasitology Test
  //     </a>
  //   ),
  // },
  // {
  //   key: "3",
  //   label: (
  //     <a  rel="noopener noreferrer" href="/dnaform">
  //       DNAMap Genetic Test
  //     </a>
  //   ),
  // },
  // {
  //   key: "4",
  //   label: (
  //     <a  rel="noopener noreferrer" href="/foodsensitivityform">
  //       FoodSensitivityMap
  //     </a>
  //   ),
  // },
  // {
  //   key: "5",
  //   label: (
  //     <a  rel="noopener noreferrer" href="/candidaform">
  //       CandidaProfile
  //     </a>
  //   ),
  // },
  // {
  //   key: "6",
  //   label: (
  //     <a  rel="noopener noreferrer" href="/oralmicrobiomeform">
  //       Oral Microbiome
  //     </a>
  //   ),
  // },
  // {
  //   key: "6",
  //   label: (
  //     <a  rel="noopener noreferrer" href="/postage">
  //       Add Kit Form
  //     </a>
  //   ),
  // },
  // {
  //   key: "7",
  //   label: (
  //     <a  rel="noopener noreferrer" href="/labrecieved">
  //       Kit Received
  //     </a>
  //   ),
  // },
  {
    key: "8",
    label: (
      <a  rel="noopener noreferrer" href="/registeryourkits">
        Register Your Kits
      </a>
    ),
  },
  {
    key: "9",
    label: (
      <a  rel="noopener noreferrer" href="/samplereturn">
        Sample Return Form
      </a>
    ),
  },
];
